export const userMultiCenter = true;
export const userAddEditMode = false;